import Module from '../../module';
import gsap from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		imageDownloadThumbWrapperCls?: string;
		imageDownloadContentItemCls?: string;
		headerCls?: string;

		anim?: {
			heHubHeSnapshotHeroHeaderCls: string;
			heHubHeSnapshotHeroImageDownloadThumbWrapperCls: string;
			heHubHeSnapshotHeroImageDownloadImageCls: string;
			heHubHeSnapshotHeroImageDownloadBtnCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub He Snapshot Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		gsap.registerPlugin(ScrollToPlugin);

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroHeaderCls || '', 'he_hub_he_snapshot_hero', { animCls: 'animate__zoomIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadThumbWrapperCls + '1', 'he_hub_he_snapshot_hero', { animCls: 'animate__flipInY', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadThumbWrapperCls + '2', 'he_hub_he_snapshot_hero', { animCls: 'animate__flipInY', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadThumbWrapperCls + '3', 'he_hub_he_snapshot_hero', { animCls: 'animate__flipInY', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadThumbWrapperCls + '4', 'he_hub_he_snapshot_hero', { animCls: 'animate__flipInY', dontClearDelay: true, once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadImageCls + '1', 'he_hub_he_snapshot_hero', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadImageCls + '2', 'he_hub_he_snapshot_hero', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadImageCls + '3', 'he_hub_he_snapshot_hero', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadImageCls + '4', 'he_hub_he_snapshot_hero', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadBtnCls + '1', 'he_hub_he_snapshot_hero', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadBtnCls + '2', 'he_hub_he_snapshot_hero', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadBtnCls + '3', 'he_hub_he_snapshot_hero', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubHeSnapshotHeroImageDownloadBtnCls + '4', 'he_hub_he_snapshot_hero', { animCls: 'animate__rotateIn', once: true});
	}

	bind() {
		this.msg('bind');

		if(this.publicVars.cssId.imageDownloadThumbWrapperCls) {
			const imageDownloadThumbs = document.querySelectorAll(this.publicVars.cssId.imageDownloadThumbWrapperCls) as NodeListOf<HTMLElement>;

			imageDownloadThumbs.forEach(thumb => {
				thumb.addEventListener('click', () => {
					this.scrollToImage(thumb.dataset?.image);
				})
			})
		}
	}

	scrollToImage(imageId?: string) {
		if(!imageId) {
			return;
		}

		let headerHeight = 0;

		if(this.publicVars.cssId.headerCls) {
			const header = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;

			headerHeight = header?.offsetHeight || 0;
		}

		const duration = 0.5 + +imageId * 0.3;

		gsap.to(window, {
			duration: duration,
			ease: 'power3.out',
			scrollTo: { y: this.publicVars.cssId.imageDownloadContentItemCls + imageId, offsetY: +headerHeight + 20 }
		});
	}
}

export default Hero;